module.exports = __webpack_public_path__ + "media/images/emblems/Krauchthal-coat_of_arms-b28b612579d6cc17e1afa248d9bedf77.svg";